import React from 'react';
import { TPAComponentsProvider } from '../../../ui';
import classNames from 'classnames';
import { getIsMobile, getIsRtl } from '../../../common/store/base-params/base-params-selectors';
import { useApi } from '../../context/api-context/use-api';
import { IS_LOCKED, ROOT } from '../../../common/constants/data-hooks';
import { useConfiguration } from '../../context/configuration-context/use-configuration';
import stStyles from '../../styles/global-styles.module.scss';
import styles from './app-wrapper.module.scss';
import cssVars from '../../styles/css-vars.module.scss';
export const AppWrapper = ({ children }) => {
    const { resourceId, hideAvatars, isLocked } = useConfiguration();
    const { isRtl, isMobile, showContainerBorderDev, ssrLoadedCorrectly } = useApi((state, _a, _h, ctx) => ({
        isRtl: getIsRtl(state),
        isMobile: getIsMobile(state),
        showContainerBorderDev: ctx.wcDevToolsState.showContainerBorder,
        ssrLoadedCorrectly: !!ctx.wcSsrLoadedCorrectly && !!ctx.wcSsrLoadedCorrectly[resourceId],
    }));
    const Wrapper = ssrLoadedCorrectly ? 'div' : 'section';
    const renderedIn = ssrLoadedCorrectly ? 'SSR_LOADED' : 'CSR_LOADED';
    return (React.createElement(Wrapper, { className: classNames(styles.root, cssVars.commentsContainer, 'wc-comments-root', {
            [styles.debugBorder]: showContainerBorderDev,
        }), dir: isRtl ? 'rtl' : 'ltr', "data-hook": classNames(ROOT, resourceId, {
            [IS_LOCKED]: isLocked,
        }), "data-render": renderedIn },
        React.createElement("div", { className: classNames(stStyles.root, Boolean(hideAvatars) && stStyles.withoutAvatars, isMobile ? 'wc-app-mobile' : 'wc-app-desktop') },
            React.createElement(TPAComponentsProvider, { value: { mobile: isMobile, rtl: isRtl } }, children))));
};
//# sourceMappingURL=app-wrapper.js.map